import styled, { css } from 'styled-components';
import React from 'react';

const GuiStyle = css`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.elvitaGray};
  font-family: ${({ theme }) => theme.fonts.light};
  letter-spacing: 0.04rem;

  @media print {
    line-height: initial;
  }
`;

const StyledSpan = styled.span<{
  $gui?: boolean;
}>`
  font-family: ${({ theme }) => theme.fonts.light};
  line-height: 0.14;

  ${({ $gui }) => $gui && GuiStyle};
`;

type SpanProps = {
  className?: string;
  lang?: string;
  children: React.ReactNode;
};

const Span: React.FC<SpanProps> = ({ children, className, lang }) => {
  const isGui = !!className && className.indexOf('gui') > -1;
  return (
    <StyledSpan $gui={isGui} className={className} lang={lang}>
      {children}
    </StyledSpan>
  );
};
export default Span;
